import React from 'react';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

export const TextCutoff = ({ label, textLimit }) => {
  if (label.length <= textLimit) {
    return label;
  }

  return (
    <Tooltip title={label}>
      {`${label.substring(0, textLimit)}...`}
    </Tooltip>
  );
};

TextCutoff.propTypes = {
  label: PropTypes.string,
  textLimit: PropTypes.number
};

TextCutoff.defaultProps = {
  label: '',
  textLimit: 20
};
